// @flow
import styled from '@emotion/styled'
import * as React from 'react'

import { colors } from '@toggl/style'

import { IconCheck } from '../icons/IconCheck'
import * as text from '../text'

type ListProps = {|
  children: React.Node,
|}

type ItemProps = {|
  children: React.Node,
|}

export const Wrapper = ({ children }: ListProps) => {
  return <Ul>{children}</Ul>
}

export const Item = ({ children }: ItemProps) => {
  return (
    <Li>
      <IconCheck color={colors.beige} />
      {children}
    </Li>
  )
}

const Ul: React.ComponentType<any> = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
`

const Li: React.ComponentType<any> = styled.li`
  ${text.paragraph2};
  margin-right: 18px;
  margin-bottom: 35px;
  display: flex;
  align-items: baseline;

  &:last-child {
    margin-bottom: 0;
  }

  svg {
    margin-right: 18px;
    flex-shrink: 0;
  }
`
